/*
  This file replicates the currency filter from AngularJS.
  This is adapted from the source code and cleaned up to pass linting.
  
  Source:
  https://github.com/angular/angular.js/blob/d8f77817eb5c98dec5317bc3756d1ea1812bcfbe/src/ng/filter/filters.js#L60-L80
*/

/* eslint-disable prefer-template */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-cond-assign */
/* eslint-disable operator-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

export const isString = value => typeof value === 'string';
export const isNumber = value => typeof value === 'number';

export const roundNumber = (parsedNumber, fractionSize, minFrac, maxFrac) => {
  const digits = parsedNumber.d;
  let fractionLen = digits.length - parsedNumber.i;

  fractionSize =
    typeof fractionSize === 'undefined'
      ? Math.min(Math.max(minFrac, fractionLen), maxFrac)
      : +fractionSize;

  let roundAt = fractionSize + parsedNumber.i;
  const digit = digits[roundAt];

  if (roundAt > 0) {
    digits.splice(Math.max(parsedNumber.i, roundAt));

    for (let j = roundAt; j < digits.length; j++) {
      digits[j] = 0;
    }
  } else {
    fractionLen = Math.max(0, fractionLen);
    parsedNumber.i = 1;
    digits.length = Math.max(1, (roundAt = fractionSize + 1));
    digits[0] = 0;
    for (let i = 1; i < roundAt; i++) {
      digits[i] = 0;
    }
  }

  if (digit >= 5) {
    if (roundAt - 1 < 0) {
      for (let k = 0; k > roundAt; k--) {
        digits.unshift(0);
        parsedNumber.i++;
      }
      digits.unshift(1);
      parsedNumber.i++;
    } else {
      digits[roundAt - 1]++;
    }
  }

  for (; fractionLen < Math.max(0, fractionSize); fractionLen++) {
    digits.push(0);
  }

  const newCarry = digits.reduceRight((carry, d, i, thisDigits) => {
    d = d + carry;
    thisDigits[i] = d % 10;
    return Math.floor(d / 10);
  }, 0);

  if (newCarry) {
    digits.unshift(newCarry);
    parsedNumber.i++;
  }
};

export const parse = argNumStr => {
  const MAX_DIGITS = 22;
  const DECIMAL_SEP = '.';
  const ZERO_CHAR = '0';
  let numStr = argNumStr;
  let exponent = 0;
  let digits;
  let numberOfIntegerDigits;

  numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP);
  if (numberOfIntegerDigits > -1) {
    numStr = numStr.replace(DECIMAL_SEP, '');
  }

  let i = numStr.search(/e/i);
  if (i > 0) {
    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
    numberOfIntegerDigits += +numStr.slice(i + 1);
    numStr = numStr.substring(0, i);
  } else if (numberOfIntegerDigits < 0) {
    numberOfIntegerDigits = numStr.length;
  }

  let zeros;
  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) {
    /* empty */
  }

  if (i === (zeros = numStr.length)) {
    digits = [0];
    numberOfIntegerDigits = 1;
  } else {
    zeros--;
    while (numStr.charAt(zeros) === ZERO_CHAR) {
      zeros--;
    }

    numberOfIntegerDigits -= i;
    digits = [];
    for (let j = 0; i <= zeros; i++, j++) {
      digits[j] = +numStr.charAt(i);
    }
  }

  if (numberOfIntegerDigits > MAX_DIGITS) {
    digits = digits.splice(0, MAX_DIGITS - 1);
    exponent = numberOfIntegerDigits - 1;
    numberOfIntegerDigits = 1;
  }

  return { d: digits, e: exponent, i: numberOfIntegerDigits };
};

export const formatNumber = (number, pattern, groupSep, decimalSep, fractionSize) => {
  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
  const isInfinity = !isFinite(number);
  let isZero = false;
  const numStr = Math.abs(number) + '';
  let formattedText = '';
  let parsedNumber;

  if (isInfinity) {
    formattedText = '\u221e';
  } else {
    parsedNumber = parse(numStr);

    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

    let digits = parsedNumber.d;
    let integerLen = parsedNumber.i;
    const exponent = parsedNumber.e;
    let decimals = [];
    isZero = digits.reduce((zero, d) => zero && !d, true);

    while (integerLen < 0) {
      digits.unshift(0);
      integerLen++;
    }

    if (integerLen > 0) {
      decimals = digits.splice(integerLen, digits.length);
    } else {
      decimals = digits;
      digits = [0];
    }

    const groups = [];
    if (digits.length >= pattern.lgSize) {
      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
    }
    while (digits.length > pattern.gSize) {
      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
    }
    if (digits.length) {
      groups.unshift(digits.join(''));
    }
    formattedText = groups.join(groupSep);

    if (decimals.length) {
      formattedText += decimalSep + decimals.join('');
    }

    if (exponent) {
      formattedText += 'e+' + exponent;
    }
  }
  if (number < 0 && !isZero) {
    return pattern.negPre + formattedText + pattern.negSuf;
  }
  return pattern.posPre + formattedText + pattern.posSuf;
};

const currencyFilter = (currencyFormat) => (amount, argCurrencySymbol, argFractionSize) => {
  let currencySymbol = argCurrencySymbol;
  let fractionSize = argFractionSize;

  if (typeof argCurrencySymbol === 'undefined') {
    currencySymbol = currencyFormat.CURRENCY_SYM;
  }

  if (typeof argFractionSize === 'undefined') {
    fractionSize = currencyFormat.PATTERNS[1].maxFrac;
  }

  const currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;

  return amount == null
    ? amount
    : formatNumber(
        amount,
        currencyFormat.PATTERNS[1],
        currencyFormat.GROUP_SEP,
        currencyFormat.DECIMAL_SEP,
        fractionSize,
      ).replace(currencySymbolRe, currencySymbol);
};

export default currencyFilter;
